import mainAxios from "../redux/api/mainAxios";

export const imageLoader = (url) => {
  if (!url) return "./assets/imgNotFound.webp";
  const imageUrl = typeof url === "string" ? url : url.url;
  return `${process.env.REACT_APP_IMAGE_END_POINT}${imageUrl}`;
};

export const uploadImage = async (file) => {
  if (!file) return null;

  const formData = new FormData();
  formData.append("files", file);

  try {
    const response = await mainAxios.post(
      `${process.env.REACT_APP_IMAGE_END_POINT}/api/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data && response.data[0]) {
      return response.data[0];
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }

  return null;
};

export const ftpUpload = async (file, remotePath) => {
  if (!file) return null;

  const formData = new FormData();
  formData.append("file", file);
  formData.append(
    "remoteBasePath",
    remotePath || "/home/stock/crawler/lots/images"
  );

  try {
    const response = await mainAxios.post(
      `${process.env.REACT_APP_ENDPOINT_URL}api/ftp-upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error("Error uploading file to FTP:", error);
    throw error;
  }

  return null;
};
